export class EquipmentDTO {
    ID: string;
    //UserEquipmentID:string;
    Name: string;
    IsChecked:boolean;
    CategoryName: string;
    ImagePath: string;
    ImageBase64 :string;
    Specification: string;
    Quantity: number;
}

export class CategoryDTO{
    CategoryId:number;
    CategoryName:string;
  //  Equipments:EquipmentDTO[];
}


export class CustomCategoryDTO{
    CategoryName:string;
  Equipments:EquipmentDTO[];
}




// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/Models/Equipment.model.ts